export default __webpack_public_path__ + "static/dge_small-image_1-2d978a4446f59d86c5504d8e3adce637.webp";